<template>
  <div class="tw-mb-4 tw-py-8 tw-px-8 tw-bg-green-500 tw-rounded-3xl tw-relative tw-text-white tw-bg-red-500">
    <p class="tw-font-bold">
      You are currently editing an upcoming order. You have until {{editOrderCutoffTime ? editOrderCutoffTime : ' the previous order starts being prepared '}} to make changes. Your original order will still be prepared and charged unless this order is placed! Once your updated order is placed, the original order will be canceled and you will not be charged for it.
    </p>
    <button class="tw-py-2 tw-underline tw-mt-8" @click="popConfirmModal">
      Nevermind, I don't want to make changes
    </button>
  </div>

  <TwModal
    v-show="confirmModalOpen"
    :hasAccept="true"
    :hasHeader="false"
    @emitClose="closeConfirmModal">

    <template v-slot:body>
      <div class="tw-relative tw-pr-24 tw-w-full">
        <h2 class="tw-mx-8 tw-font-black tw-text-5xl tw-mb-6 lg:tw-my-8">Are you sure?</h2>
      </div>

      <p class="tw-mx-8 tw-mb-8 tw-text-3xl !tw-leading-relaxed">
        Your current bag will be cleared, your changes will not be saved and your previous order will still be prepared. Are you sure you want to stop editing this order?
      </p>
    </template>

    <template v-slot:footer>
      <div class="tw-flex tw-justify-center tw-items-center tw-px-8 tw-pt-16 tw-pb-8 lg:tw-mb-4">
        <TwButton 
          cssClass="tw-bg-orange-medium tw-border-2 tw-border-orange-medium tw-text-white hover:tw-bg-black hover:tw-border-black tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200 tw-mr-8 tw-rounded-full tw-inline-block"
          @emit-click="handleClick" 
          :isLoading="confirming"
          :isDisabled="confirming" 
          :buttonText="'Stop Editing'"/>

        <TwButton 
          cssClass="tw-border-2 tw-border-gray-400 tw-text-gray-400 hover:tw-bg-orange-medium hover:tw-border-orange-medium hover:tw-text-white tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200 tw-ml-8 tw-rounded-full"
          @emit-click="closeConfirmModal" 
          :isLoading="false"
          :isDisabled="false" 
          :buttonText="'Continue Editing'"/>
      </div>
    </template>
  </TwModal>
</template>

<script setup lang="ts">
import Basket from '../classes/Basket';
import { computed, ref } from 'vue'  
import { DateTime } from "luxon";

import TwModal from './TwModal.vue';
import TwButton from './TwButton.vue';

const props = defineProps({
  cutoffTime: {
    type: String,
    required: true
  }
})

const emit = defineEmits(['cancelEditOrder'])
const confirmModalOpen = ref(false)
const confirming = ref(false)

const editOrderCutoffTime = computed(() => {
  let cutoff = ""
  if (props.cutoffTime) {
    let cutoffTime = props.cutoffTime;
    let dt = DateTime.fromISO(cutoffTime);
    cutoff = dt.toFormat('LLLL d') + nth(dt.day) + ' at ' + dt.toFormat('h:mma')
  }

  return cutoff
})

const handleClick = () => {
  confirming.value = true;
  window.setTimeout(() => {
    emit('cancelEditOrder')
    confirming.value = false;
  }, 500)
}

const nth = (number: number) => {
  if (number > 3 && number < 21) return "th";
  switch (number % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};

const popConfirmModal = () => {
  confirmModalOpen.value = true;
}

const closeConfirmModal = () => {
  confirmModalOpen.value = false;
}

</script>